import { render, staticRenderFns } from "./ModalErroImpressao.vue?vue&type=template&id=3706f544&scoped=true"
import script from "./ModalErroImpressao.vue?vue&type=script&lang=js"
export * from "./ModalErroImpressao.vue?vue&type=script&lang=js"
import style0 from "./ModalErroImpressao.vue?vue&type=style&index=0&id=3706f544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3706f544",
  null
  
)

export default component.exports